module.exports = __webpack_public_path__ + "img/home-carrinho.6b4177de.png";